export default {
  retrievePlaceList (state, payload) {
    state.placeList = [].concat(payload.placeList)
  },
  getPlaceInfo (state, payload) {
    state.placeInfo = payload.placeInfo
  },
  deletePlace (state, payload) {
    let index = state.placeList.findIndex((item) => item.id == payload.placeInfo.place_id)

    if (index !== -1) {
        state.placeList.splice(index, 1)
    }
  },
  updateState (state, payload) {
    state.currentFilter = payload.filter ? Object.assign({}, payload.filter) : null
    state.currentSort = payload.sort ? Object.assign({}, payload.sort) : null
    state.currentPage = payload.page ? payload.page : null
  }
}
